import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import { signOutUser } from '../../actions/userActions';
import { withRouter } from 'react-router-dom';
import { trackPageView } from '@forwardfinancing/analytics-frontend-library/index';
import { buildSignOutUrl } from '../../lib/authSignOut';

export class LogoutPage extends React.Component {
  componentDidMount() {
    trackPageView({page: 'Logout'});
    this.props.signOutUser();
    window.location.assign(buildSignOutUrl());
  }

  render() {
    return (
      <div/>
    );
  }
}

LogoutPage.propTypes = {
  signOutUser: PropTypes.func.isRequired,
};

export default withRouter(connect(() => {
  return {};
}, {
  signOutUser
})(LogoutPage));
